import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

function fetchAnticipationIndexDetails (startDate, endDate, thumbnail, anticipation) {
  const body = {
    start_date: startDate,
    end_date: endDate,
    thumbnail: thumbnail,
    anticipation: anticipation
  }
  return utils.makeApiCall({
    url: '/api/v2/insights/attention/index/engagements',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_ANTICIPATION_INDEX,
    actionReceive: ActionTypes.RECEIVE_ANTICIPATION_INDEX,
    actionFailure: ActionTypes.REQUEST_ANTICIPATION_INDEX_FAILURE,
    authenticated: true,
    actionProps: {
      startDate,
      endDate,
      thumbnail,
      anticipation
    }
  })
}

function fetchTopContentIndexDetails (startDate, endDate, thumbnail, anticipation) {
  const body = {
    start_date: startDate,
    end_date: endDate,
    thumbnail: thumbnail,
    anticipation: anticipation
  }
  return utils.makeApiCall({
    url: '/api/v2/insights/attention/index/engagements',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOP_CONTENT_INDEX,
    actionReceive: ActionTypes.RECEIVE_TOP_CONTENT_INDEX,
    actionFailure: ActionTypes.REQUEST_TOP_CONTENT_INDEX_FAILURE,
    authenticated: true,
    actionProps: {
      startDate,
      endDate,
      thumbnail,
      anticipation
    }
  })
}

function fetchGlobalAttentionScoreDetails (startDate, endDate, thumbnail) {
  const body = {
    start_date: startDate,
    end_date: endDate,
    thumbnail: thumbnail
  }
  return utils.makeApiCall({
    url: '/api/insights/attention/index/engagements',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_ANTICIPATION_INDEX_SCORE,
    actionReceive: ActionTypes.RECEIVE_ANTICIPATION_INDEX_SCORE,
    actionFailure: ActionTypes.REQUEST_ANTICIPATION_INDEX_SCORE_FAILURE,
    authenticated: true,
    actionProps: {
      startDate,
      endDate,
      thumbnail
    }
  })
}

function fetchTrendingIndexDetails (startDate, endDate, previousStartDate, previousEndDate) {
  const body = {
    start_date: startDate,
    end_date: endDate,
    previous_start_date: previousStartDate,
    previous_end_date: previousEndDate
  }
  return utils.makeApiCall({
    url: '/api/v2/insights/attention/index/trending',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_INDEX,
    actionReceive: ActionTypes.RECEIVE_TRENDING_INDEX,
    actionFailure: ActionTypes.REQUEST_TRENDING_INDEX_FAILURE,
    authenticated: true,
    actionProps: {
      startDate,
      endDate,
      previousStartDate,
      previousEndDate
    }
  })
}

function fetchCancelledShowsDetails (startDate, endDate) {
  const body = {
    start_date: startDate,
    end_date: endDate
  }
  return utils.makeApiCall({
    url: '/api/v2/insights/attention/index/cancelled/shows',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX,
    actionReceive: ActionTypes.RECEIVE_CANCELLED_SHOWS_INDEX,
    actionFailure: ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX_FAILURE,
    authenticated: true,
    actionProps: {
      startDate,
      endDate
    }
  })
}

export function fetchAnticipationIndexIfNeeded (startDate, endDate) {
  return (dispatch, getState) => {
    const selectedDate = startDate + '_' + endDate
    const state = getState().globalAttentionIndex.anticipationViewDetails && getState().globalAttentionIndex.anticipationViewDetails[selectedDate] || {}
    if (utils.shouldFetch(state)) {
      return dispatch(fetchAnticipationIndexDetails(startDate, endDate, true, true))
    }
  }
}

export function fetchTopContentIndexIfNeeded (startDate, endDate) {
  return (dispatch, getState) => {
    const selectedDate = startDate + '_' + endDate
    const state = getState().globalAttentionIndex.topContentViewDetails && getState().globalAttentionIndex.topContentViewDetails[selectedDate] || {}
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTopContentIndexDetails(startDate, endDate, true, false))
    }
  }
}

export function fetchTrendingIndexIfNeeded (startDate, endDate, previousStartDate, previousEndDate) {
  return (dispatch, getState) => {
    const selectedDate = startDate + '_' + endDate
    const state = getState().globalAttentionIndex.trendingViewDetails && getState().globalAttentionIndex.trendingViewDetails[selectedDate] || {}
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrendingIndexDetails(startDate, endDate, previousStartDate, previousEndDate))
    }
  }
}

export function fetchCancelledShowsDetailsIfNeeded (startDate, endDate) {
  return (dispatch, getState) => {
    const selectedDate = startDate + '_' + endDate
    const state = getState().globalAttentionIndex.cancelledShowsDetails && getState().globalAttentionIndex.cancelledShowsDetails[selectedDate] || {}
    if (utils.shouldFetch(state)) {
      return dispatch(fetchCancelledShowsDetails(startDate, endDate, true, false))
    }
  }
}

export function fetchGlobalAttentionScoreIfNeeded (startDate, endDate) {
  return (dispatch) => {
    return dispatch(fetchGlobalAttentionScoreDetails(startDate, endDate, false))
  }
}

export function setSelectedAttentionIndexDate (date) {
  return {
    type: ActionTypes.SELECTED_ATTENTION_INDEX_DATE,
    date
  }
}

export function setSelecteddAttentionIndexView (view) {
  return {
    type: ActionTypes.SELECTED_ATTENTION_INDEX_VIEW,
    view
  }
}